import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/about", label: "About Us" },
  { to: "/our-work", label: "Our Work" },
  { to: "/zimbabwe", label: "Zimbabwe" },
  { to: "/our-impact", label: "Our Impact" },
  { to: "/governance", label: "Governance" },
  { to: "/get-involved", label: "Get Involved" },
  { to: "/news", label: "News" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const linkCls = ({ isActive }) =>
    `text-sm font-medium tracking-wide transition-colors duration-300 ${
      isActive ? "text-forest" : "text-charcoal hover:text-forest"
    }`;
  return (
    <header className="sticky top-0 z-40 bg-ivory/95 backdrop-blur-sm border-b border-sandstone">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:bg-forest focus:text-white focus:px-4 focus:py-2 focus:z-50">
        Skip to main content
      </a>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src="/logo-emblem-green.png" alt="Mount Moriah Relief logo" className="h-11 w-auto" />
          <span className="font-serif text-xl sm:text-2xl font-semibold text-forest leading-none">
            Mount Moriah Relief
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkCls} data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/donate"
            data-testid="nav-donate-button"
            className="bg-forest text-white text-sm font-medium px-6 py-2.5 hover:bg-forest-dark transition-colors duration-300"
          >
            Donate
          </Link>
        </nav>
        <button
          className="lg:hidden p-2 text-charcoal"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden bg-ivory border-t border-sandstone" aria-label="Mobile">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="font-serif text-2xl text-charcoal hover:text-forest transition-colors duration-300"
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/donate"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-donate-button"
              className="mt-2 bg-forest text-white text-center font-medium px-6 py-3.5 hover:bg-forest-dark transition-colors duration-300"
            >
              Donate
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
